import { likes } from "@/api/interface.js";

//  点赞
const likesFn = (ev, isLikes, likeNum, fileId) => {
  return new Promise(async (resolve, reject) => {
    let $el = $(ev.currentTarget);
    if (isLikes) {
      isLikes = false;
      let { data } = await likes({ fileIds: [fileId], action: "dec" });
      $el.removeClass("favor");
      likeNum--;
      likeNum = likeNum <= 0 ? 0 : likeNum;
    } else {
      isLikes = true;
      let { data } = await likes({ fileIds: [fileId], action: "inc" });
      $el.addClass("favor");

      if (String(likeNum).includes("+")) return;
      likeNum++;
      likeNum = likeNum > 999 ? "999+" : likeNum;
    }

    resolve({ likeNum, isLikes });
  });
};

export { likesFn };
